import { Block } from '../../../services/entities/impl/blfApi/schemas/block';
import { Customer } from '../../../services/entities/impl/blfApi/schemas/customer';
import { Ranch } from '../../../services/entities/impl/blfApi/schemas/ranch';
import { Scan } from '../../../services/entities/impl/blfApi/schemas/scan';

/**
 * Function to concatenate the name properties of given Customer, Ranch, Block, and Scan.
 * For Customer, Ranch, and Block, the 'name' property is used.
 * For Scan, the 'scanDate' property is used.
 * Each defined property is delimited by " / " in the resulting string.
 *
 * @param customer - An optional Customer object
 * @param ranch - An optional Ranch object
 * @param block - An optional Block object
 * @param scan - An optional Scan object
 * @return A string with the name or scanDate of each defined input, delimited by " / ".
 */
export function concatenateItemNames(
  customer?: Customer | undefined,
  ranch?: Ranch | undefined,
  block?: Block | undefined,
  scan?: Scan | undefined
): string {
  const parts: string[] = [];

  if (customer) {
    parts.push(customer.name);
  }

  if (ranch) {
    parts.push(ranch.name);
  }

  if (block) {
    parts.push(block.name);
  }

  if (scan) {
    parts.push(scan.scanDate);
  }

  return parts.join(' / ');
}
